var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"modal-primary",class:_vm.tamanho,attrs:{"title":_vm.title,"hide-footer":true},model:{value:(_vm.visualiza),callback:function ($$v) {_vm.visualiza=$$v},expression:"visualiza"}},[_c('div',{staticClass:"content-iframe"},[_c('iframe',{ref:"iframeModal",staticStyle:{"height":"100%","width":"100%","border":"0"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df511dae","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/super-modal.vue
// module id = 830
// module chunks = 245